import gql from 'graphql-tag';

export const calendarSeriesQuery = gql`
  query getSeries($slug: [String]) {
    eventSerieses(where: { slug: $slug }) {
      nodes {
        eventSeriesId
        name
        slug
        description
        eventOccurrences(first: 1000) {
          nodes {
            end {
              day
              meridiem
              month
              time
              timezone
              year
              weekday
            }
            excerpt
            eventSlug
            featuredImage {
              node {
                altText
                description
                mediaDetails {
                  height
                  width
                }
                sourceUrl
              }
            }
            start {
              day
              isoDate
              meridiem
              month
              time
              timezone
              year
              weekday
            }
            title
            timezoneAbbr
          }
        }
        featuredImage {
          altText
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
        imageSrcset
        seriesDescription
      }
    }
  }
`;
